import { atom } from "recoil";
import PackageUmrahModel from "../Models/packageUmrahModel";

export const DefaultTemplateUmrah = new atom({
  default: new PackageUmrahModel(),
  key: "DefaultTemplateUmrah",
});
